let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("g0ygn")).then(() => parcelRequire('aIMZz'));